module.exports = __webpack_public_path__ + "img/1.a5d82b54.jpg";